import React from 'react';
import { useTitle } from "fearless-common-ui";
import {Apple, Windows} from "react-bootstrap-icons";
import Fold from "../components/layout/Fold";
import downloadAppleWindows from './../assets/images/backgrounds/download-apple-windows.jpg';
import {concepts} from "fearless-common";
import {Alert} from "react-bootstrap";
import links from "../libs/downloadLinks";

const btnClasses = 'd-inline-flex align-items-center px-4 mb-1';
const height = '49px';

export default function DownloadPhoto51() {
    useTitle(`Download ${concepts.Photo51}`);

    return (
        <>
            <Fold className="d-block d-sm-none">
                <Fold.Main>
                    <h1>Download {concepts.Photo51}</h1>
                    <Alert variant="warning" className="mx-4 mt-3">
                        {concepts.Photo51} is a desktop software. Please log into this website on a
                        desktop to download {concepts.Photo51}.
                    </Alert>
                </Fold.Main>
            </Fold>
            <Fold
                className="d-none d-sm-flex justify-content-center align-items-center"
                overlay="dark"
                fullHeight
                backgroundImage={downloadAppleWindows}
            >
                <h1 className="mb-5 text-white">Download {concepts.Photo51}</h1>
                <div className="d-flex justify-content-center align-items-start pb-5 gap-5">
                    <div className="d-inline-flex flex-column gap-2">
                        <a
                          className={`btn btn-primary ${btnClasses}`}
                          style={{ height }}
                          target="_blank"
                          rel="noreferrer"
                          href={links.macArm}
                        >
                            <span className="text-xl position-relative" style={{top: '-4px'}}>
                                <Apple className="me-2"/>
                            </span>
                            <span>
                                <b>MacOS</b> (Silicon M-series)
                            </span>
                        </a>
                        <a
                          className={`btn btn-outline-primary bg-neutral-700 text-white border-0 ${btnClasses}`}
                          style={{height}}
                          target="_blank"
                          rel="noreferrer"
                          href={links.mac}
                        >
                            <span className="text-xl position-relative" style={{top: '-4px'}}>
                                <Apple className="me-2"/>
                            </span>
                            <span>
                            Olders <b>Macs</b> (intel based)
                          </span>
                        </a>
                    </div>
                    <a className={`btn btn-primary ${btnClasses}`} target="_blank" rel="noreferrer" href={links.win}
                       style={{height }}>
                        <span className="text-xl position-relative" style={{top: '-3px'}}>
                            <Windows className="me-2"/>
                        </span>
                        <span>Download for <b>Windows</b></span>
                    </a>
                </div>
                <div className="py-5" />
                <div className="py-5" />
            </Fold>
        </>
    );
}
